import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonCard = ({ count = 1, height = 20, circle = false, style }) => {
  return (
    <>
      {[...Array(count)].map((_, i) => (
        <Skeleton
          key={i}
          height={height}
          circle={circle}
          // customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 50%, var(--base-color) 60%)"
          style={{
            width: circle ? `${height}px` : "100%",
            marginBottom: "1rem",
            borderRadius: "10px",
            ...style,
          }}
        />
      ))}
    </>
  );
  
};


export default SkeletonCard;
